import { Component } from '@angular/core'
import { LoginIntroService, LoginIntroState } from 'src/app/services/login-intro.service'

/**
 * Hosted once in app.component.html. The prototype's "Turbine" sign-in intro: a black overlay wipes in from the
 * Sign In button, the submark spins up out of a red glow inside a spinning ring, "Technician App" rises under
 * it, then the mark blows through the viewer behind a red flash and the overlay fades over the schedule.
 * Timings are the prototype's, expressed against T (total seconds) and sd = T - .25.
 */
@Component({
  selector: 'rt-login-intro',
  template: `
    <div *ngIf="intro.state$ | async as s" class="rt-intro" aria-hidden="true" [style]="vars(s)">
      <div class="rt-intro__glow"></div>
      <div class="rt-intro__ring"><div></div></div>
      <img class="rt-intro__mark" src="assets/brand/swirl.png" alt="" />
      <div class="rt-intro__label">Technician App</div>
      <div class="rt-intro__flash"></div>
    </div>`,
})
export class RtLoginIntroComponent {
  constructor(readonly intro: LoginIntroService) {}

  vars(s: LoginIntroState): string {
    const sd = s.T - 0.25
    return `--T:${s.T}s; --sd:${sd}s; --sd7:${sd * 0.7}s; --out:${s.T - 0.3}s; --flash:${s.T - 0.75}s; --origin:${s.origin}`
  }
}
